import { createSelector } from 'reselect';

import {
  getApiHandlerReady,
  getCouponOrderingMethod,
  getFreeChoiceOrderingMethod,
} from './config';
import getEnabledPaymentMethods from './getEnabledPaymentMethods';

export default createSelector(
  [
    getApiHandlerReady,
    getCouponOrderingMethod,
    getFreeChoiceOrderingMethod,
    getEnabledPaymentMethods,
  ],
  (
    apiHandlerReady,
    couponOrderingMethod,
    freeChoiceOrderingMethod,
    enabledPaymentMethods,
  ): boolean => {
    return (
      apiHandlerReady &&
      !!couponOrderingMethod &&
      !!freeChoiceOrderingMethod &&
      !!enabledPaymentMethods.length
    );
  },
);
